<template>
  <div id="choose-platform">
    <ul>
      <li @click="choosePlat(item.platFormName)" v-for="item in platformLists" :class="{'current-platform': currentPlatform === item.platFormName}">
        <img :src="'/static/img/downloadNew/' + item.iconName + '.svg'" alt="" :class="item.iconName">{{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapState } from 'vuex'

  export default {
    name: 'choose-platform',
    data: function () {
      return {
        windows: {
          name: 'Windows',
          platFormName: 'windows',
          iconName: 'ic_windows',
          sort: 1
        },
        mac: {
          name: 'macOS',
          platFormName: 'mac',
          iconName: 'ic_macos',
          sort: 2
        },
        ios: {
          name: 'iOS',
          platFormName: 'ios',
          iconName: 'ic_apple',
          sort: 3
        },
        android: {
          name: 'Android',
          platFormName: 'android',
          iconName: 'ic_android',
          sort: 4
        },
        androidTV: {
          name: 'Android TV',
          platFormName: 'androidTV',
          iconName: 'ic_androidTV',
          sort: 6
        },
        ubuntu: {
          name: 'Linux',
          platFormName: 'ubuntu',
          iconName: 'ic_linux',
          sort: 5
        }
      }
    },
    computed: {
      platformLists() {
        let arr = []
        arr.push(this.windows)
        arr.push(this.mac)
        arr.push(this.ios)
        arr.push(this.android)
        arr.push(this.androidTV)
        arr.push(this.ubuntu)
        return _.sortBy(arr, 'sort')
      },
      ...mapState({
        currentPlatform: state => state.download.currentPlatform,
        mediaType: state => state.mediaType,
      })
    },
    methods: {
      choosePlat(platform) {
        this.$store.commit('setCurrentPlatform', platform)
        this.$router.push(`/download?platform=${platform}`)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "choosePlatform";
</style>



// WEBPACK FOOTER //
// ChoosePlatform.vue?7ec697c0